import smartsaleLogo from '../smartsale-logo.png';
import smartsaleLogoIcon from '../smartsale-logo-icon.svg';
import smartsaleOverlay from '../smartsale-overlay.svg';
const images = { smartsaleLogo, smartsaleLogoIcon, smartsaleOverlay };
export { images };
//# sourceMappingURL=index.js.map